import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

import { ModalService } from '@app/shared/services/modal.service';
import { InputsService } from '../../../inputs/services/inputs.service';
import { UserMediaService } from '@app/learner-home/services/user-media.service';

import {
  MediaEntry,
  UserMediaParameters,
} from '../../../inputs/inputs-api.model';
import { InputShowFormParams } from '../../../inputs/inputs.model';

import { FeedVideoModalComponent } from '@app/learner-home/components/feed-video-modal/feed-video-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FeedVideoModalService {
  constructor(
    private modalService: ModalService,
    private inputsService: InputsService,
    private userMediaService: UserMediaService
  ) {}

  /**
   * Shows the {@link FeedVideoModalComponent} following recording of a new video, to allow creation as a new input
   * @param {Partial<InputShowFormParams>} options
   * @returns {Observable<unknown>}
   */
  public create({
    organizationId,
    initialModel: initialViewModel,
  }: Partial<InputShowFormParams<MediaEntry>>) {
    const submit = (params: UserMediaParameters) =>
      forkJoin([
        this.userMediaService.addNewInput(params, 'Feed'), // add a user completion for the video
        this.inputsService.addMedia(params, false), // also add to content catalog
      ]).pipe(map((r) => r[0]));

    return this.modalService.show(FeedVideoModalComponent, {
      inputs: {
        submit,
        initialViewModel: {
          ...initialViewModel,
          organizationId,
        },
      },
      windowClass: 'lg-modal',
    });
  }
}
